import { addIcons } from 'ionicons';
import {
    add as addIcon,
    alertCircle as alertCircleIcon,
    alertCircleOutline as alertCircleOutlineIcon,
    arrowDown as arrowDownIcon,
    arrowDownOutline as arrowDownOutlineIcon,
    arrowForward as arrowForwardIcon,
    arrowForwardOutline as arrowForwardOutlineIcon,
    arrowRedo as arrowRedoIcon,
    attach as attachIcon,
    attachOutline as attachOutlineIcon,
    barChartOutline as barChartOutlineIcon,
    bookOutline as bookOutlineIcon,
    bookmark as bookmarkIcon,
    bookmarkOutline as bookmarkOutlineIcon,
    briefcase as briefcaseIcon,
    briefcaseOutline as briefcaseOutlineIcon,
    bulbOutline as bulbOutlineIcon,
    business as businessIcon,
    businessOutline as businessOutlineIcon,
    calendarClearOutline as calendarClearOutlineIcon,
    calendarNumberOutline as calendarNumberOutlineIcon,
    calendarOutline as calendarOutlineIcon,
    camera as cameraIcon,
    caretDownOutline as caretDownOutlineIcon,
    chatbubblesOutline as chatbubblesOutlineIcon,
    checkbox as checkboxIcon,
    checkmarkCircle as checkmarkCircleIcon,
    checkmarkCircleOutline as checkmarkCircleOutlineIcon,
    checkmarkDoneCircle as checkmarkDoneCircleIcon,
    checkmarkDoneCircleOutline as checkmarkDoneCircleOutlineIcon,
    checkmarkDoneSharp as checkmarkDoneSharpIcon,
    checkmarkOutline as checkmarkOutlineIcon,
    chevronBack as chevronBackIcon,
    chevronBackOutline as chevronBackOutlineIcon,
    chevronDown as chevronDownIcon,
    chevronDownCircleOutline as chevronDownCircleOutlineIcon,
    chevronDownOutline as chevronDownOutlineIcon,
    chevronForward as chevronForwardIcon,
    chevronForwardOutline as chevronForwardOutlineIcon,
    chevronUpOutline as chevronUpOutlineIcon,
    close as closeIcon,
    closeCircleOutline as closeCircleOutlineIcon,
    closeOutline as closeOutlineIcon,
    closeSharp as closeSharpIcon,
    document as documentIcon,
    documentTextOutline as documentTextOutlineIcon,
    downloadOutline as downloadOutlineIcon,
    ellipseOutline as ellipseOutlineIcon,
    ellipsisHorizontalCircleOutline as ellipsisHorizontalCircleOutlineIcon,
    eye as eyeIcon,
    eyeOff as eyeOffIcon,
    informationCircleOutline as informationCircleOutlineIcon,
    libraryOutline as libraryOutlineIcon,
    listOutline as listOutlineIcon,
    locationOutline as locationOutlineIcon,
    locationSharp as locationSharpIcon,
    lockClosedOutline as lockClosedOutlineIcon,
    logoUsd as logoUsdIcon,
    mailOpenOutline as mailOpenOutlineIcon,
    mailOutline as mailOutlineIcon,
    mapOutline as mapOutlineIcon,
    navigateCircleOutline as navigateCircleOutlineIcon,
    navigateOutline as navigateOutlineIcon,
    newspaper as newspaperIcon,
    notificationsOutline as notificationsOutlineIcon,
    openOutline as openOutlineIcon,
    pencilOutline as pencilOutlineIcon,
    pencilSharp as pencilSharpIcon,
    peopleOutline as peopleOutlineIcon,
    personCircle as personCircleIcon,
    personOutline as personOutlineIcon,
    phonePortraitOutline as phonePortraitOutlineIcon,
    powerOutline as powerOutlineIcon,
    qrCodeOutline as qrCodeOutlineIcon,
    receiptOutline as receiptOutlineIcon,
    refresh as refreshIcon,
    ribbonOutline as ribbonOutlineIcon,
    rocketOutline as rocketOutlineIcon,
    save as saveIcon,
    school as schoolIcon,
    schoolOutline as schoolOutlineIcon,
    searchOutline as searchOutlineIcon,
    send as sendIcon,
    settingsOutline as settingsOutlineIcon,
    shieldCheckmarkOutline as shieldCheckmarkOutlineIcon,
    shieldHalfOutline as shieldHalfOutlineIcon,
    star as starIcon,
    starOutline as starOutlineIcon,
    swapHorizontalOutline as swapHorizontalOutlineIcon,
    sync as syncIcon,
    telescopeOutline as telescopeOutlineIcon,
    timeOutline as timeOutlineIcon,
    trash as trashIcon,
    trashOutline as trashOutlineIcon,
    trendingUpOutline as trendingUpOutlineIcon,
    trophyOutline as trophyOutlineIcon,
    warning as warningIcon
} from 'ionicons/icons';

export function registerIonicIcons() {
    addIcons({
        'add': addIcon,
        'alert-circle': alertCircleIcon,
        'alert-circle-outline': alertCircleOutlineIcon,
        'arrow-down': arrowDownIcon,
        'arrow-down-outline': arrowDownOutlineIcon,
        'arrow-forward': arrowForwardIcon,
        'arrow-forward-outline': arrowForwardOutlineIcon,
        'arrow-redo': arrowRedoIcon,
        'attach': attachIcon,
        'attach-outline': attachOutlineIcon,
        'bar-chart-outline': barChartOutlineIcon,
        'book-outline': bookOutlineIcon,
        'bookmark': bookmarkIcon,
        'bookmark-outline': bookmarkOutlineIcon,
        'briefcase': briefcaseIcon,
        'briefcase-outline': briefcaseOutlineIcon,
        'bulb-outline': bulbOutlineIcon,
        'business': businessIcon,
        'business-outline': businessOutlineIcon,
        'calendar-clear-outline': calendarClearOutlineIcon,
        'calendar-number-outline': calendarNumberOutlineIcon,
        'calendar-outline': calendarOutlineIcon,
        'camera': cameraIcon,
        'caret-down-outline': caretDownOutlineIcon,
        'chatbubbles-outline': chatbubblesOutlineIcon,
        'checkbox': checkboxIcon,
        'checkmark-circle': checkmarkCircleIcon,
        'checkmark-circle-outline': checkmarkCircleOutlineIcon,
        'checkmark-done-circle': checkmarkDoneCircleIcon,
        'checkmark-done-circle-outline': checkmarkDoneCircleOutlineIcon,
        'checkmark-done-sharp': checkmarkDoneSharpIcon,
        'checkmark-outline': checkmarkOutlineIcon,
        'chevron-back': chevronBackIcon,
        'chevron-back-outline': chevronBackOutlineIcon,
        'chevron-down': chevronDownIcon,
        'chevron-down-circle-outline': chevronDownCircleOutlineIcon,
        'chevron-down-outline': chevronDownOutlineIcon,
        'chevron-forward': chevronForwardIcon,
        'chevron-forward-outline': chevronForwardOutlineIcon,
        'chevron-up-outline': chevronUpOutlineIcon,
        'close': closeIcon,
        'close-circle-outline': closeCircleOutlineIcon,
        'close-outline': closeOutlineIcon,
        'close-sharp': closeSharpIcon,
        'document': documentIcon,
        'document-text-outline': documentTextOutlineIcon,
        'download-outline': downloadOutlineIcon,
        'ellipse-outline': ellipseOutlineIcon,
        'ellipsis-horizontal-circle-outline': ellipsisHorizontalCircleOutlineIcon,
        'eye': eyeIcon,
        'eye-off': eyeOffIcon,
        'information-circle-outline': informationCircleOutlineIcon,
        'library-outline': libraryOutlineIcon,
        'list-outline': listOutlineIcon,
        'location-outline': locationOutlineIcon,
        'location-sharp': locationSharpIcon,
        'lock-closed-outline': lockClosedOutlineIcon,
        'logo-usd': logoUsdIcon,
        'mail-open-outline': mailOpenOutlineIcon,
        'mail-outline': mailOutlineIcon,
        'map-outline': mapOutlineIcon,
        'navigate-circle-outline': navigateCircleOutlineIcon,
        'navigate-outline': navigateOutlineIcon,
        'newspaper': newspaperIcon,
        'notifications-outline': notificationsOutlineIcon,
        'open-outline': openOutlineIcon,
        'pencil-outline': pencilOutlineIcon,
        'pencil-sharp': pencilSharpIcon,
        'people-outline': peopleOutlineIcon,
        'person-circle': personCircleIcon,
        'person-outline': personOutlineIcon,
        'phone-portrait-outline': phonePortraitOutlineIcon,
        'power-outline': powerOutlineIcon,
        'qr-code-outline': qrCodeOutlineIcon,
        'receipt-outline': receiptOutlineIcon,
        'refresh': refreshIcon,
        'ribbon-outline': ribbonOutlineIcon,
        'rocket-outline': rocketOutlineIcon,
        'save': saveIcon,
        'school': schoolIcon,
        'school-outline': schoolOutlineIcon,
        'search-outline': searchOutlineIcon,
        'send': sendIcon,
        'settings-outline': settingsOutlineIcon,
        'shield-checkmark-outline': shieldCheckmarkOutlineIcon,
        'shield-half-outline': shieldHalfOutlineIcon,
        'star': starIcon,
        'star-outline': starOutlineIcon,
        'swap-horizontal-outline': swapHorizontalOutlineIcon,
        'sync': syncIcon,
        'telescope-outline': telescopeOutlineIcon,
        'time-outline': timeOutlineIcon,
        'trash': trashIcon,
        'trash-outline': trashOutlineIcon,
        'trending-up-outline': trendingUpOutlineIcon,
        'trophy-outline': trophyOutlineIcon,
        'warning': warningIcon
    });
}
